import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketDashboard } from '../components/MarketDashboard';
import { SubprimalsTable } from '../components/SubprimalsTable';
import { MarketIQNav } from '../components/MarketIQNav';
import { Activity, Layers, Calendar, DollarSignIcon, TrendingUpIcon, BarChart2Icon } from 'lucide-react';
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const generateCurve = (base: number, volatility: number, trend: number, length: number) => {
  let current = base;
  return Array.from({
    length
  }).map(() => {
    current += (Math.random() - 0.5) * volatility + trend;
    return Number(current.toFixed(2));
  });
};
const beef2024 = generateCurve(2.8, 0.05, 0.01, 12);
const beef2025 = generateCurve(3.3, 0.06, 0.005, 12);
const beef2026 = generateCurve(3.5, 0.08, 0.02, 4);
const beefData = months.map((month, i) => ({
  month,
  val2024: beef2024[i],
  val2025: beef2025[i],
  val2026: i < 4 ? beef2026[i] : null
}));
export function MarketIQ() {
  return <MarketIQLayout activeSection="beef" data-id="element-505">
      <MarketDashboard label="BEEF CUTOUT VALUES" title="Beef Cutout Values" subtitle="Current pricing and analysis for boxed beef cutout values" chartTitle="Beef Cutout ($/lb) - Choice, Daily" currentPrice="$3.83" currentPriceNum={3.83} priceChange={{
      value: '$0.05',
      isNegative: true
    }} historicalChanges={[{
      label: '1W',
      value: '$0.13',
      isNegative: true
    }, {
      label: '1M',
      value: '$0.09',
      isNegative: true
    }, {
      label: '1Y',
      value: '+$0.43',
      isNegative: false
    }]} lastReportDate="Apr 7, 2026" filters={[{
      icon: <Activity className="w-4 h-4" data-id="element-507" />,
      label: 'Cutout'
    }, {
      icon: <Layers className="w-4 h-4" data-id="element-508" />,
      label: 'Choice'
    }, {
      icon: <Calendar className="w-4 h-4" data-id="element-509" />,
      label: 'Daily'
    }]} chartData={beefData} yAxisDomain={[2.51, 4.24]} yAxisTicks={[2.51, 2.86, 3.2, 3.55, 3.89, 4.24]} data-id="element-506" />
      <MarketIQNav current="beef" data-id="element-510" />
      <SubprimalsTable data-id="element-511" />
    </MarketIQLayout>;
}